<template>
    <app-ghost-mode>
        <div class="row">
            <div class="col-12">
                <div class="jumbotron screen-center">
                    <div class="negotiate-header pt-3">
                        <h3 class="md-small-text text-center">Apply Sale Rule <i class="fas fa-tags fa-sm ml-2"></i></h3>
                    </div>
                    <!-- Alert Messages -->
                    <dl v-if="msg !== ''" class="row mt-3 mb-n3">
                        <dd class="col-12">
                            <div :class="`alert alert-${color} text-center mb-n2 p-1`" role="alert">
                                <i class="fas fa-exclamation-circle"></i> {{ msg }}
                            </div>
                        </dd>
                    </dl>
                    <div class="price-box">
                        <p class="mt-4 mb-2">Sales rule to be applied</p>
                        <div class="form-group">
                            <input type="text" class="form-control no-lines bg-white" :value="theRule.name" readonly>
                        </div>
                        <!-- first ensure user has items for sale -->
                        <template v-if="mySellings">
                            <div class="form-group">
                                Apply this rule on: 
                                <input v-model="applyType" type="radio" name="applyOnAll" id="negotiable" value="allItems" checked> 
                                <label for="negotiable" class="mx-2">All Items</label> 

                                <input v-model="applyType" type="radio" name="applyOnAll" id="nonNegotiable" value="items"> 
                                <label for="nonNegotiable" class="mx-2">Selected Items</label>

                                <input v-model="applyType" type="radio" name="applyOnAll" id="forDonation" value="categories"> 
                                <label for="forDonation" class="mx-2">Selected Categories</label>
                            </div>

                            <!-- category options -->
                            <template v-if="applyType === 'categories'">
                                <p class="mt-4 mb-2">Select all categories that apply</p>
                                <div class="form-group">
                                    <select v-model="selectedCategories" multiple class="custom-select no-lines bg-white">
                                        <option disabled value="">Select multiple categories</option>
                                        <option disabled><hr></option>
                                        <option v-for="(category, i) in categories" :key="i" :value="category">
                                            {{category | capitalize}}
                                        </option>
                                    </select>
                                </div>
                            </template>

                            <!-- item options -->
                            <template v-if="applyType === 'items'">
                                <p class="mt-4 mb-2">Select all items that apply</p>
                                <div class="form-group">
                                    <select v-model="selectedItems" multiple class="custom-select no-lines bg-white">
                                        <option disabled value="">Select multiple items</option>
                                        <option disabled><hr></option>
                                        <option v-for="(item, i) in mySellings" :key="i" :value="item._id">
                                            {{item.title | capitalize}}
                                        </option>
                                    </select>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <p class="text-danger text-center">You don't have any item to be sold at this time!</p>
                        </template>

                        <p class="mt-4 mb-2">Specify the duration</p>
                        <div class="form-inline">
                            <div class="input-group mr-2">
                                <div class="input-group-prepend">
                                    <div class="input-group-text bg-light text-dark-green">Sale Starts</div>
                                </div>
                                <input v-model="startDate" type="date" class="form-control no-lines bg-white">
                            </div>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text bg-light text-dark-green">Sale Stops</div>
                                </div>
                                <input v-model="stopDate" type="date" class="form-control no-lines bg-white">
                            </div>
                        </div>
                    </div>
                    <div class="text-center mt-4">
                        <button @click="applySaleFxn" v-bind="{ 'disabled' : !mySellings }" class="loadn btn btn-dark-green">
                            Apply Now
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </app-ghost-mode>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import GhostMode from '@/components/general/shared/GhostMode.vue'

export default {
    name: "ApplySale",
    props: ['theRule'],
    data() {
        return {
            applyType: '',
            msg: '',
            color: 'danger',
            startDate: null,
            stopDate: null,
            categories: [],
            selectedItems: [],
            selectedCategories: [],
        }
    },
    methods: {
        ...mapActions(['itemsIamSelling', 'applySalesRule', 'createTransaction']),
        extractSellerCategories() {
            if(this.sellings && this.sellings !== null && this.categories.length == 0){
                // loop through items to fecth their categories
                let categoriesArr = []
                let uniqueCategories = []
                for(let x=0; x < this.sellings.length; x++){
                    // ensure the item is not yet sold
                    if(this.sellings[x].sold === false){
                        categoriesArr.push(this.sellings[x].category)
                    }
                }
                // ensure no category is duplicated from the categoriesArr
                this.categories = [...new Set(categoriesArr)]
            }
        },
        extractCategoriesItemIds() {
            this.selectedItems = []
            if(this.mySellings && this.selectedCategories.length){
                for(let x=0; x < this.selectedCategories.length; x++){
                    let categoryItems = this.mySellings.filter(item => item.category == this.selectedCategories[x])
                    for(let y=0; y < categoryItems.length; y++){
                        this.selectedItems.push(categoryItems[y]._id)
                    }
                }
            }
        },
        extractAllItemIds() {
            this.selectedItems = []
            if(this.mySellings){
                for(let x=0; x < this.mySellings.length; x++){
                    this.selectedItems.push(this.mySellings[x]._id)
                }
            }
        },
        applySaleFxn() {
            this.color = "danger"
            if(this.applyType === ''){ this.msg = "Select where you'd like to apply this rule!"; return }
            if(this.startDate === null){ this.msg = "Select a start date for this rule!"; return }
            if(this.stopDate === null){ this.msg = "Select a stop date for this rule!"; return }
            
            // ensure user doesnt select a past date
            let todaysDate = new Date()
            let yesterday = new Date(todaysDate)
            yesterday.setDate(yesterday.getDate() - 1)
            yesterday = new Date(yesterday).getTime()
            let startDate = new Date(this.startDate).getTime()
            let stopDate = new Date(this.stopDate).getTime()
            if(startDate < yesterday){ this.msg = "Your start date cannot be in the past!"; return }
            if(stopDate <= startDate){ this.msg = "Stop date should be at least 24hrs from start date!"; return }

            // extract the itemIds if allItems was selected
            if(this.applyType === "allItems"){
                this.extractAllItemIds()
            }
            // extract the itemIds if categories was selected
            if(this.applyType === "categories"){
                this.extractCategoriesItemIds()
            }
            
            let ruleObj = {
                userId: this.user._id,
                ruleId: this.theRule.id,
                starts: startDate,
                stops: stopDate,
                itemIds: this.selectedItems,
                categories: this.selectedCategories,
            }
            this.applySalesRule(ruleObj)
            .then((data) => {
                if(!data.error){
                    this.color = "success"
                    this.applyType = ''
                    this.selectedItems = []
                    this.startDate = null
                    this.stopDate = null

                    // save transaction log for sales-rule-application
                    let eventObj = {
                        userId: this.user._id,
                        salesId: data.result._id,
                        event: `sales rule "${data.result.name}" applied on ${data.result.itemIds.length} items, discounting ${data.result.percentage}% off their original prices`
                    }
                    this.createTransaction(eventObj).then(() => {}).catch((e) => {})
                }
                this.msg = data.msg
            })
        },
    },
    computed: {
        ...mapGetters(['user', 'sellings']),
        mySellings() {
            if(this.sellings && this.sellings !== null){
                this.extractSellerCategories()
                return this.sellings.filter(item => item.sold !== true )
            }
            return false
        },
    },
    components: {
        appGhostMode: GhostMode,
    },
    created() {
        if(!this.sellings){
            this.itemsIamSelling().then(() => {}).catch((e) => {})
        }
    }
}
</script>